export default {
    // Event logged when the message options panel is opened but has no content.
    MessageOptionsEmptyInvariantViolation: {
        datapoint: {
            name: 'MessageOptionsEmptyInvariantViolation',
            options: {
                isQos: true,
            },
        },
    },
    // Event logged when the dialog is opened multiple times
    MessageOptionsMultipleDialogsInvariantViolation: {
        datapoint: {
            name: 'MessageOptionsMultipleDialogsInvariantViolation',
            options: {
                isQos: true,
            },
        },
    },
};
